var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{class:[_vm.$style.debug, ( _obj = {}, _obj[_vm.$style.active] = _vm.debugPWA, _obj )],on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }